export const splitLeadName = (name: string) => {
  return name.trim().split(/\s+/);
};
